import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/services/development/DevelopmentClient.tsx");
